import React, { createContext, useContext, useEffect, useState } from "react";
import { useWebsiteConfigQuery } from "hooks/useWebsiteConfig";

const ThemeConfigContext = createContext();

export const ThemeConfigProvider = ({ children }) => {
  const { data: config, isLoading } = useWebsiteConfigQuery();
  const [activeDesign, setActiveDesign] = useState(() => {
    return window?.siteConfig?.active_design || "bc";
  });

  useEffect(() => {
    if (config && config.active_design) {
      setActiveDesign(config.active_design);
    }
  }, [config]);

  return (
    <ThemeConfigContext.Provider value={{ activeDesign, setActiveDesign, isLoading, config: config || window?.siteConfig }}>
      {children}
    </ThemeConfigContext.Provider>
  );
};

export const useThemeConfig = () => {
  const context = useContext(ThemeConfigContext);
  if (!context) {
    throw new Error("useThemeConfig must be used within a ThemeConfigProvider");
  }
  return context;
};
